import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';

import { TranslateModule } from '@ngx-translate/core';

import { GalaxyButtonGroupModule } from '@vendasta/galaxy/button-group';
import { GalaxyI18NModule } from '@vendasta/galaxy/i18n';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';

import { EmailViewerComponent } from './email-viewer.component';
import { GalaxyLoadingSpinnerModule } from '@vendasta/galaxy/loading-spinner';
export { EmailViewerComponent };

export const MODULE_IMPORTS = [
  CommonModule,
  MatIconModule,
  GalaxyButtonGroupModule,
  GalaxyI18NModule,
  GalaxyPipesModule,
  MatButtonModule,
  MatButtonToggleModule,
  TranslateModule,
];

export const MODULE_DECLARATIONS = [EmailViewerComponent];

@NgModule({
  declarations: MODULE_DECLARATIONS,
  imports: [MODULE_IMPORTS, GalaxyLoadingSpinnerModule],
  exports: [EmailViewerComponent],
})
export class GalaxyEmailViewerModule {}
